import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Grid, Link, Flex } from "@chakra-ui/react";
import { LandscapeImage} from "../ImageComponents";
import Breadcrumb from "../components/Breadcrumb";

const Proyects = () => {
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };

  // Left column (Projects and People)
  const leftColumn = [
    {
      title: t('breadcrumbs.entreOlas'),
      link: "/projects/entre-olas",
      imgSrc: "/images/entre-olas.jpg",
      component: LandscapeImage,
    },
  ];

  return (
    <Box
      maxWidth="1400px" // Limit page width to align with header
      margin="0 auto"
      padding="20px"
      paddingTop={{ base: "80px", md: "20px" }}
      pr="5%"
      pl="5%"
    >
      {/* Breadcrumb */}
      <Box mb={6}>
        <Breadcrumb 
          items={[
            { label: t('breadcrumbs.work'), href: getLocalizedPath('/') },
            { label: t('breadcrumbs.projects') }
          ]} 
        />
      </Box>

      <Grid
        templateColumns={{ base: "1fr", md: "1fr 1fr" }} // Two columns for desktop
        // gap={10} // Consistent horizontal gap
        gap={5} // Consistent horizontal gap
      >
        {/* Left Column */}
        <Box>
          {leftColumn.map(({ title, link, imgSrc, component: Component }, index) => (
            <Link
              key={index}
              onClick={() => navigate(getLocalizedPath(link))}
              _hover={{ textDecoration: "none" }}
              width="100%"
              cursor="pointer"
            >
              <Flex
                flexDirection="column"
                alignItems="center"
                width="100%"
                marginBottom={10} // Consistent vertical spacing between sections
              >
                {/* Render the Appropriate Image Component with Title */}
                <Component src={imgSrc} alt={title} title={title} />
              </Flex>
            </Link>
          ))}
        </Box>
      </Grid>
    </Box>
  );
};

export default Proyects;